import { FC, ReactElement, useCallback } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';

import { ForceMobileProvider } from '@mopla/utils';

import { Loader } from '../../atoms/loader/Loader';
import { Responsive } from '../../molecules/Responsive';
import PassengerBottomNavigation, {
	EPassengerNavTab,
} from '../../organisms/PassengerBottomNavigation/PassengerBottomNavigation';

import { DesktopCenteredRoot, RootMobile } from './PassengerHomeLayout.styles';

interface HomeProps {
	searchContent: ReactElement;
	bookingsContent: ReactElement;
	profileContent: ReactElement;
	initialLoading: boolean;
	mobileHomeContent: ReactElement;
	activitiesContent?: ReactElement;
	onBottomTabClick?: (tab: EPassengerNavTab) => void;
}

// props are only for the current development purposes.
export const PassengerHomeLayout: FC<HomeProps> = ({
	searchContent,
	bookingsContent,
	profileContent,
	initialLoading,
	mobileHomeContent,
	activitiesContent,
	onBottomTabClick,
}) => {
	const { pathname } = useLocation();

	const getVariant = useCallback(() => {
		switch (pathname) {
			case '/home/tickets':
			case '/home/activities': {
				return 'primary.main';
			}

			case '/home/search': {
				return 'neutral.0';
			}

			case '/home/profile': {
				return 'primary.dark';
			}

			default: {
				return 'neutral.0';
			}
		}
	}, [pathname]);

	const content = (
		<>
			{initialLoading ? (
				<Loader />
			) : (
				<Routes>
					<Route path="search" element={searchContent} />
					<Route path="tickets" element={bookingsContent} />
					<Route path="activities" element={activitiesContent} />
					<Route path="profile" element={profileContent} />
					<Route index element={mobileHomeContent} />
					<Route path="*" element={<Navigate to="/" replace />} />
				</Routes>
			)}

			<PassengerBottomNavigation onTabClick={onBottomTabClick} />
		</>
	);

	return (
		<>
			<Responsive aboveMobile>
				<ForceMobileProvider value={true}>
					<DesktopCenteredRoot variant={getVariant()} className="force-mobile">
						{content}
					</DesktopCenteredRoot>
				</ForceMobileProvider>
			</Responsive>
			<Responsive mobile>
				<RootMobile variant={getVariant()}>{content}</RootMobile>
			</Responsive>
		</>
	);
};
